import { render, staticRenderFns } from "./OrderProductList.vue?vue&type=template&id=9ca33b94"
import script from "./OrderProductList.vue?vue&type=script&lang=js"
export * from "./OrderProductList.vue?vue&type=script&lang=js"
import style0 from "./OrderProductList.vue?vue&type=style&index=0&id=9ca33b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports